/** 将服务端笔记转为 Quill 可用的 HTML；旧版纯文本会包一层段落并转义 */

export function coerceNotesToHtmlForEditor(raw: string | undefined | null): string {
  const s = raw ?? '';
  if (!s.trim()) return '';
  if (/<[a-z][\s\S]*>/i.test(s)) return s;
  return `<p>${s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r\n/g, '\n')
    .replace(/\n/g, '<br/>')}</p>`;
}

function escapeHtmlForNote(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** 将翻译结果追加到笔记 HTML 末尾 */
export function appendTranslationToNotesHtml(prevHtml: string, translatedPlain: string): string {
  const t = translatedPlain.trim();
  if (!t) return prevHtml;
  const block = `<p><strong>【翻译】</strong></p><p>${escapeHtmlForNote(t).replace(/\n/g, '<br/>')}</p>`;
  const base = (prevHtml || '').trim();
  if (!base || base === '<p><br></p>') return block;
  return `${base}<p><br></p>${block}`;
}
